// extracted by mini-css-extract-plugin
module.exports = {"table":"index_table_2FaSS","textDivider":"index_textDivider_3JUQy","textDividerContent":"index_textDividerContent_3lZcs"};